import DefaultPage from '@components/defaultPage';
import Scanner from '@components/scanner';
import { useTranslator } from '@i18n';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { handleError } from '@util/errors';
import parseCode from '@util/parseCode';

export const Route = createFileRoute('/scanner/')({
  component: ScannerPage,
});

function ScannerPage() {
  const t = useTranslator();
  const navigate = useNavigate();

  return (
    <DefaultPage
      backButton={{ to: '/' }}
      title={t('scanner.button')}
      css={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Scanner
        onScan={(text) => {
          const result = parseCode(text);

          if (result.type === 'device') {
            navigate({
              to: `/inventory/$deviceType/$deviceId`,
              params: { deviceType: result.deviceType, deviceId: result.uid },
              state: { fromScanner: true },
            });
          } else {
            handleError(`${t('scanner.unknownCode')}: ${text}`);
          }
        }}
        css={{
          flex: 1,
          margin: 'calc(0px - var(--mantine-spacing-md))',
          marginTop: 0,
          justifySelf: 'center',
          background: 'black',
        }}
      />
    </DefaultPage>
  );
}
